/* FOLLIVA INSTRUMENT — scroll reveal + count-up (editor / reduced-motion safe) */
(function () {
  "use strict";
  var FL = window.FL || {};
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var editor = window.Shopify && window.Shopify.designMode;
  var motionOff = (FL.settings && FL.settings.motion === false);

  function markGroups(root) {
    (root || document).querySelectorAll("[data-fl-reveal-group]").forEach(function (g) {
      var kids = g.querySelectorAll("[data-fl-reveal]");
      for (var i = 0; i < kids.length; i++) if (!kids[i].style.getPropertyValue("--fl-i")) kids[i].style.setProperty("--fl-i", i);
    });
  }
  function revealAll(root) {
    (root || document).querySelectorAll("[data-fl-reveal]").forEach(function (el) { el.classList.add("is-revealed"); });
  }
  function countUp(el) {
    var target = parseFloat((el.getAttribute("data-count-to") || el.textContent).replace(/[^0-9.]/g, ""));
    if (isNaN(target)) return;
    var dec = (String(target).split(".")[1] || "").length;
    var suffix = el.getAttribute("data-count-suffix") || "";
    var start = performance.now(), dur = 700;
    function tick(now) {
      var p = Math.min(1, (now - start) / dur), e = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * e).toFixed(dec) + suffix;
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function run() {
    markGroups(document);
    if (reduce || motionOff || editor || !("IntersectionObserver" in window)) { revealAll(document); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        el.classList.add("is-revealed");
        if (el.getAttribute("data-fl-reveal") === "count" && FL.settings && FL.settings.countUp !== false) countUp(el);
        io.unobserve(el);
      });
    }, { threshold: 0.2, rootMargin: "0px 0px -8% 0px" });
    document.querySelectorAll("[data-fl-reveal]").forEach(function (el) { io.observe(el); });
    window._flIO = io;
  }

  (document.readyState !== "loading") ? run() : document.addEventListener("DOMContentLoaded", run);

  document.addEventListener("shopify:section:load", function (e) {
    markGroups(e.target);
    revealAll(e.target); /* editor: show immediately */
  });
})();
